import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import userReducer from "../app/pages/user/userSlice";
import dashboardReducer from "../app/pages/dashboard/dashboardSlice";
import businessParameterReducer from "../app/pages/businessParameter/businessParameterSlice";
import menuReducer from "../app/pages/menu/menuSlice";
import officeReducer from "../app/pages/office/officeSlice";
import businessGroupReducer from "../app/pages/businessGroup/businessGroupSlice";
import motorPoolReducer from "../app/pages/motorPool/motorPoolSlice";
import clientReducer from "../app/pages/client/clientSlice";
import partyReducer from "../app/pages/party/partySlice";
import locationReducer from "../app/pages/location/locationSlice";
import productRelatedReducer from "../app/pages/productRelated/ProductRelatedSlice";
import miscellaneousReducer from "../app/pages/miscellaneous/MiscellaneousSlice";
import locationManagementReducer from "../app/pages/locationManagement/locationManagementSlice";
import inboundReducer from "../app/pages/inbound/inboundSlice";
import bookingReducer from "../app/pages/booking/bookingSlice";
import OutboundReducer from "../app/pages/outbound/outboundSlice";
import inventoryReducer from "../app/pages/inventory/inventorySlice";
import maintenanceReducer from "../app/pages/maintenance/maintenanceSlice";
import stocktakeReducer from "../app/pages/stocktake/stocktakeSlice";
import movementReducer from "../app/pages/movement/movementSlice";
import infoUpdateReducer from "../app/pages/infoUpdate/infoUpdateSlice";
import activityReducer from "../app/pages/activity/activitySlice";
import userPolicyReducer from "../app/pages/policy/policySlice";
import reportingReducer from "../app/pages/report/reportingSlice";
import reportIssueReducer from "../app/pages/reportIssue/reportIssueSlice";
import sapStatusReducer from "../app/pages/sapStatus/sapStatusSlice";
import transactionLogReducer from "../app/pages/transactionLog/transactionLogSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  dashboard: dashboardReducer,
  user: userReducer,
  businessParameter: businessParameterReducer,
  menu: menuReducer,
  office: officeReducer,
  businessGroup: businessGroupReducer,
  motorPool: motorPoolReducer,
  client: clientReducer,
  party: partyReducer,
  location: locationReducer,
  productRelated: productRelatedReducer,
  miscellaneous: miscellaneousReducer,
  locationManagement: locationManagementReducer,
  inbound: inboundReducer,
  booking: bookingReducer,
  Outbound: OutboundReducer,
  inventory: inventoryReducer,
  maintenance: maintenanceReducer,
  stocktake: stocktakeReducer,
  movement: movementReducer,
  infoUpdate: infoUpdateReducer,
  activity: activityReducer,
  userPolicy: userPolicyReducer,
  reporting: reportingReducer,
  reportIssue: reportIssueReducer,
  sapStatus: sapStatusReducer,
  transactionLog: transactionLogReducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
